import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadData as loadDataLatest } from './TransactionPage.duck';
import TransactionPageNew from './TransactionPageNew/TransactionPageNew';
import TransactionPageLegacy from './TransactionPageLegacy/TransactionPage';
import { isLegacyTransaction, getTransactionCutoverDate } from '../../util/transactionCutover';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { storableError } from '../../util/errors';
import { types as sdkTypes } from '../../util/sdkLoader';

const { UUID } = sdkTypes;

const TransactionPageRouter = props => {
  const { params, transactionRole } = props;
  const dispatch = useDispatch();
  const txId = params?.id ? new UUID(params.id) : null;
  const transaction = useSelector(state =>
    txId ? getMarketplaceEntities(state, [{ id: txId, type: 'transaction' }])[0] : null
  );

  const cutover = getTransactionCutoverDate();

  useEffect(() => {
    if (!txId || transaction) return;
    dispatch(loadDataLatest({ ...params, transactionRole }, null, null)).catch(e => {
      console.error(storableError(e));
    });
  }, [txId, transaction, dispatch, params, transactionRole]);

  if (!transaction) {
    // Use latest skeleton while loading
    return <TransactionPageNew {...props} loadingOverride />;
  }

  const isLegacy = isLegacyTransaction(transaction, cutover);

  // If legacy but route name is OrderDetailsPage/SaleDetailsPage still fine; component handles role.
  const Component = isLegacy ? TransactionPageLegacy : TransactionPageNew;
  return <Component {...props} transaction={transaction} />;
};

// Loader uses latest duck to preserve SSR/data needs; it returns promise compatible with Routes
export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  return dispatch(loadDataLatest(params, search, config));
};

export { setInitialValues } from './TransactionPage.duck';

export default TransactionPageRouter;
